import { createSelector } from 'reselect';
import { initialState } from '../components/AppStructure/portal_slice';
import { createActionStatusesSelector, createStatusForActionSelector, } from '../utils/action_statuses_helper';
import { PENDING_MEMBER_STATUS_STRING } from '../constants/values';
export var getPortalData = function (state) { return state.portalData; };
export var getIsAdmin = createSelector(getPortalData, function (portalData) {
    return (Array.isArray(portalData.teamAccountRoles) &&
        portalData.teamAccountRoles.some(function (accountRole) { return accountRole.role === 'ADMIN'; }));
});
export var getIsPendingMember = createSelector(getPortalData, function (portalData) {
    var _a;
    return ((_a = portalData === null || portalData === void 0 ? void 0 : portalData.teamMember) === null || _a === void 0 ? void 0 : _a.status) === PENDING_MEMBER_STATUS_STRING;
});
export var getTeamName = createSelector(getPortalData, function (portalData) {
    var _a, _b;
    return (_b = (_a = portalData === null || portalData === void 0 ? void 0 : portalData.team) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : null;
});
export var getTeamId = createSelector(getPortalData, function (portalData) {
    var _a, _b;
    return (_b = (_a = portalData === null || portalData === void 0 ? void 0 : portalData.team) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
});
export var getCurrentTeamMember = createSelector(getPortalData, function (portalData) {
    var _a;
    return (_a = portalData === null || portalData === void 0 ? void 0 : portalData.teamMember) !== null && _a !== void 0 ? _a : null;
});
export var getTeamAccounts = createSelector(getPortalData, function (portalData) {
    var _a;
    return (_a = portalData === null || portalData === void 0 ? void 0 : portalData.teamAccounts) !== null && _a !== void 0 ? _a : [];
});
export var getTeamMemberEmail = createSelector(getPortalData, function (portalData) {
    var _a, _b;
    return (_b = (_a = portalData === null || portalData === void 0 ? void 0 : portalData.teamMember) === null || _a === void 0 ? void 0 : _a.email) !== null && _b !== void 0 ? _b : '';
});
export var getPortalActionStatuses = createActionStatusesSelector(getPortalData, initialState);
export var getStatusForPortalAction = createStatusForActionSelector(getPortalActionStatuses);
